var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tabs',{staticClass:"pc-tabs",on:{"change":_vm.handleChange},model:{value:(_vm.activeKey),callback:function ($$v) {_vm.activeKey=$$v},expression:"activeKey"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }